import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, splitKnown } from "../utils";

export class ProductVersionStudioLabelKeysModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    elements: {
      label: "Element label keys",
      fieldType: "json",
      minRows: 6,
    },
    groups: {
      label: "Group label keys",
      fieldType: "json",
      minRows: 6,
    },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  elements!: Record<string, string>;
  groups!: Record<string, string>;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("elements", {});
    this.defineObservableValue("groups", {});
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product version studioLabelKeys");
    this.elements =
      source.elements &&
      typeof source.elements === "object" &&
      !Array.isArray(source.elements)
        ? cloneValue(source.elements as Record<string, string>)
        : {};
    this.groups =
      source.groups &&
      typeof source.groups === "object" &&
      !Array.isArray(source.groups)
        ? cloneValue(source.groups as Record<string, string>)
        : {};
    this.extra = splitKnown(source, ["elements", "groups"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(Object.keys(this.elements).length > 0
        ? { elements: cloneValue(this.elements) }
        : {}),
      ...(Object.keys(this.groups).length > 0
        ? { groups: cloneValue(this.groups) }
        : {}),
    };
  }
}
